import { useState } from "react";
import type { BillingPortalFlow } from "../../../utils/billing-shared";
import { getBillingPortalUrl } from "../utils/billingUrls";

export function useBillingPortal() {
    const [opening, setOpening] = useState(false);
    const [error, setError] = useState("");

    /** Opens the Stripe portal in a new tab, on one task's screen when a flow is given. */
    const openPortal = async (flow?: BillingPortalFlow) => {
        // Open during the click so a slow session request cannot trigger popup blocking.
        const portalWindow = window.open("about:blank", "_blank");
        if (!portalWindow) {
            setError("Please allow pop-ups for this site, then try again.");
            return;
        }
        portalWindow.opener = null;
        setOpening(true);
        setError("");
        try {
            const response = await fetch(getBillingPortalUrl(), {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(
                    flow
                        ? {
                              flow,
                          }
                        : {},
                ),
            });
            const body = await response.json();
            if (!response.ok || typeof body.url !== "string" || !body.url) {
                setError(body.error_description || "Unable to open billing portal. Please try again.");
                portalWindow.close();
                return;
            }
            if (!portalWindow.closed) {
                portalWindow.location.replace(body.url);
            }
        } catch {
            portalWindow.close();
            setError("Unable to open billing portal. Please try again.");
        } finally {
            setOpening(false);
        }
    };

    return {
        opening,
        error,
        openPortal,
    };
}
